module.exports = __webpack_public_path__ + "img/minion_render_thumb2.9081e501.jpg";